import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { LANDING_COLORS, LANDING_FONTS } from '../landingVisual';

const FeatureCard = ({ title, description, icon }) => (
  <Card
    elevation={0}
    sx={{
      height: '100%',
      fontFamily: LANDING_FONTS.sans,
      border: '1px solid',
      borderColor: LANDING_COLORS.line,
      borderRadius: 2,
      boxShadow: 'none',
      transition: 'border-color 160ms ease, transform 160ms ease',
      '&:hover': {
        borderColor: 'primary.light',
        transform: 'translateY(-2px)',
      },
    }}
  >
    <CardContent sx={{ p: 3 }}>
      {icon && (
        <Box
          sx={{
            mb: 1.5,
            width: 40,
            height: 40,
            borderRadius: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: LANDING_COLORS.mist,
            color: LANDING_COLORS.accent,
          }}
        >
          {icon}
        </Box>
      )}
      <Typography
        variant="h6"
        component="h3"
        sx={{ fontFamily: LANDING_FONTS.sans, fontWeight: 700, letterSpacing: '-0.02em', mb: 1 }}
      >
        {title}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ fontFamily: LANDING_FONTS.sans, lineHeight: 1.7 }}
      >
        {description}
      </Typography>
    </CardContent>
  </Card>
);

export default FeatureCard;
